<input
    #input
    autocomplete="off"
    [type]="inputType()"
    [id]="labelForId()"
    [value]="inputValue()"
    [min]="minStr()"
    [max]="maxStr()"
    [step]="step()"
    [readonly]="readonly()"
    [required]="!readonly() && !!required()"
    [disabled]="disabled() === true"
    (focus)="onFocus($event)"
    (input)="onInput($event)"
    (change)="onInputChange($event)"
    (blur)="onBlur()"
/>
